(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    let slideIndex = 1;
    const sliderContainer = document.querySelector('.hero-slider');
    if (!sliderContainer) return;

    const slides = sliderContainer.querySelectorAll('.hero-slide');
    const dots = sliderContainer.querySelectorAll('.dot');
    const autoplay = sliderContainer.dataset.autoplay === 'true';
    const speed = parseInt(sliderContainer.dataset.speed) * 1000;
    let slideInterval;

    function showSlides(n) {
        if (n > slides.length) {slideIndex = 1}
        if (n < 1) {slideIndex = slides.length}
        
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));

        slides[slideIndex - 1].classList.add('active');
        dots[slideIndex - 1].classList.add('active');
    }

    window.currentSlide = function(n) {
        clearInterval(slideInterval);
        showSlides(slideIndex = n);
        if(autoplay) startAutoplay();
    }

    function startAutoplay() {
        if (autoplay && slides.length > 1) {
            slideInterval = setInterval(function() {
                slideIndex++;
                showSlides(slideIndex);
            }, speed);
        }
    }

    if (slides.length > 0) {
        startAutoplay();
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    let slideIndex = 1;
    const sliderContainer = document.querySelector('.hero-slider');
    if (!sliderContainer) return;

    const slides = sliderContainer.querySelectorAll('.hero-slide');
    const dots = sliderContainer.querySelectorAll('.dot');
    const autoplay = sliderContainer.dataset.autoplay === 'true';
    const speed = parseInt(sliderContainer.dataset.speed) * 1000;
    let slideInterval;

    function showSlides(n) {
        if (n > slides.length) {slideIndex = 1}
        if (n < 1) {slideIndex = slides.length}
        
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));

        slides[slideIndex - 1].classList.add('active');
        dots[slideIndex - 1].classList.add('active');
    }

    window.currentSlide = function(n) {
        clearInterval(slideInterval);
        showSlides(slideIndex = n);
        if(autoplay) startAutoplay();
    }

    function startAutoplay() {
        if (autoplay && slides.length > 1) {
            slideInterval = setInterval(function() {
                slideIndex++;
                showSlides(slideIndex);
            }, speed);
        }
    }

    if (slides.length > 0) {
        startAutoplay();
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
